import { TransactionListConstants } from "../_constants/TransactionList.constants";
import { alertActions } from "./alert.actions";
import {
  APIcallFunction,
  headerForPrivateAPI,
} from "../_helpers";


function TransactionListPromise(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/transaction/getTransactionListAdmin",
  };
  return APIcallFunction(credentials)
}

function TransactionList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/transaction/getTransactionListAdmin",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        // dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: TransactionListConstants.GET_TRANSACTION_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: TransactionListConstants.GET_TRANSACTION_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: TransactionListConstants.GET_TRANSACTION_LIST_FAILURE,
      error,
    };
  }
}
//Fiat Currency
function getFiatList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/fiatCurrency/getFiatCurrencyList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return { type: TransactionListConstants.GET_FIATCURRENCY_LIST_REQUEST, user };
  }
  function success(user) {
    return { type: TransactionListConstants.GET_FIATCURRENCY_LIST_SUCCESS, user };
  }
  function failure(error) {
    return { type: TransactionListConstants.GET_FIATCURRENCY_LIST_FAILURE, error };
  }
}
//create
function addFiat(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/fiatCurrency/createFiatCurrency",
  };
  return APIcallFunction(credentials)
}


//update
function updateFiat(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/fiatCurrency/updateFiatCurrency",
  };
  return APIcallFunction(credentials)
}

//delete
function deleteFiat(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/fiatCurrency/deleteFiatCurrency",
  };
  return APIcallFunction(credentials)
}

function UpdateFiatStatus(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/fiatCurrency/updateFiatCurrencyStatus",
  };
  return APIcallFunction(credentials)
}

function getOrderList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/order/orderList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (order) => {
        dispatch(success(order));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(order) { return { type: TransactionListConstants.GET_ORDERDEATILS_LIST_REQUEST, order } }
  function success(order) { return { type: TransactionListConstants.GET_ORDERDEATILS_LIST_SUCCESS, order } }
  function failure(error) { return { type: TransactionListConstants.GET_ORDERDEATILS_LIST_FAILURE, error } }
}

function adminReleaseOrder(data, refreshData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/order/adminReleaseOrder'
  };
  return (dispatch) => {
    APIcallFunction(credentials).then(
      (res) => {
        dispatch(alertActions.success(res?.message || "Order released successfully"));
        if (refreshData) dispatch(getOrderList(refreshData));
      },
      (error) => {
        dispatch(alertActions.error(error));
      }
    );
  };
}

function adminCancelOrder(data, refreshData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/order/adminCancelOrder'
  };
  return (dispatch) => {
    APIcallFunction(credentials).then(
      (res) => {
        dispatch(alertActions.success(res?.message || "Order cancelled and refunded successfully"));
        if (refreshData) dispatch(getOrderList(refreshData));
      },
      (error) => {
        dispatch(alertActions.error(error));
      }
    );
  };
}

export const TransactionListActions = {
  TransactionList,
  getFiatList,
  addFiat,
  updateFiat,
  deleteFiat,
  UpdateFiatStatus,
  getOrderList,
  TransactionListPromise,
  adminReleaseOrder,
  adminCancelOrder
};